let timerPointer = null;
const saveTimer = (id, timer) => {
  try {
    const serializatedTimer = JSON.stringify(timer);
    sessionStorage.setItem(`v-s-t${id}`, serializatedTimer);
  } catch (error) {
    console.log('Error setting timer');
  }
};

const getTimer = id => {
  try {
    const serializatedTimer = sessionStorage.getItem(`v-s-t${id}`);
    return JSON.parse(serializatedTimer);
  } catch (error) {
    return null;
  }
};

export const setTimer = timer => {
  clearTimeout(timerPointer);
  return new Promise(resolve => {
    const { delay, id } = timer;
    const sTimer = getTimer(id);
    const currentTime = Date.now();
    if (
      !sTimer ||
      currentTime > sTimer.timestamp + sTimer.delay ||
      delay !== sTimer.delay
    ) {
      saveTimer(id, { ...timer, timestamp: currentTime });
      timerPointer = setTimeout(() => resolve(timer), delay);
      return;
    }
    const newDelay = sTimer.timestamp + sTimer.delay - currentTime;
    timerPointer = setTimeout(() => resolve(sTimer), newDelay);
  });
};
